import { createGlobalStyle } from 'styled-components/macro';
import { colorCoreBackground1000, colorCoreWhite1000 } from '@yme/tokens/colors';
import { BREAKPOINT } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
export const GlobalStyles = createGlobalStyle `
  html {
    min-width: ${BREAKPOINT.xs}px;
  }

  body {
    margin: 0;
    padding: 0;

    background-color: ${colorCoreBackground1000};
  }

  img,
  embed,
  object,
  video {
    max-width: 100%;
  }
  
  /* Temporary solution */

  html,
  body.page,
  body.page #spa-root,
  body.page #spa-root > div > div.aem-container {
    min-height: 100vh;
  }
  
  /* for aem dev env */
  body.page #spa-root > div > .aem-page, 
  body.page #spa-root > div > .aem-page > div, 
  body.page #spa-root > div > .aem-page > div > div.aem-container {
    min-height: 100vh;
  }
  
  body.page #spa-root > div > div.aem-container,
  body.page #spa-root > div > .aem-page > div > div.aem-container {
    display: flex;
    flex-direction: column;
  }

  body.page #spa-root > div > div.aem-container > div.aem-GridColumn:last-child,
  body.page #spa-root > div > .aem-page > div > div.aem-container > div.aem-GridColumn:last-child {
    margin-top: auto;
  }

  // TODO (A.H.) - need to reimplement generation of items for the countries
  .items-with-icons div:first-child {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  #modal-window-portal-root {
    z-index: 100;
  }
`;
export const GlobalKioskStyles = createGlobalStyle `
  body.basicpage {
    main .aem-container > .aem-GridColumn {
      margin-top: ${INDENT.m};
    }

    main .aem-container > .aem-GridColumn:last-child {
      margin-bottom: ${INDENT.m};
    }

    [class*=SeparatorWrapper]:empty {
      display: none;
    }

    div[data-testid*=section-wrapper],
    div[data-testid*=home_test-ride],
    div[data-testid*=category-selector-panel] > div {
      border-radius: ${INDENT.xs};
      background: ${colorCoreWhite1000};
      padding-bottom: 0;
      padding-top: 0;
    }
    div[data-testid*=home_test-ride],
    div[data-testid*=section-wrapper] {
      padding: ${INDENT.xl} 0;
    }
  }
`;
